import { render, staticRenderFns } from "./agentAccount.vue?vue&type=template&id=28aee8f0&scoped=true&"
import script from "./agentAccount.vue?vue&type=script&lang=js&"
export * from "./agentAccount.vue?vue&type=script&lang=js&"
import style0 from "./agentAccount.vue?vue&type=style&index=0&id=28aee8f0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aee8f0",
  null
  
)

export default component.exports